import React from 'react';
import PropTypes from 'prop-types';
import {__t} from '../lang/text-resource';

export function ConvertToEUR(value) {
	if (!value) {
		return 0;
	}

	return (value / 1.95583).toFixed(2);
}

export function FormatPrice(value, currency, removeDoubleZeros) {
	const currencyMap = {
		BGN: 'лв',
		EUR: '€',
		USD: '$',
	};


	if (removeDoubleZeros) {
		value = value.replace('.00', '');
		value = value.replace(',00', '');
	} else {
		value = value.toFixed(2);
	}

	if (typeof (value) === 'string') {
		value = value.replace('.', ',');
	}

	if (currency === '') {
		return value;
	}

	if (currency === 'BGN') {
		return `${value} ${currencyMap[currency]}`;
	} else {
		return `${currencyMap[currency]} ${value}`;
	}
}

const Price = ({
				   value,
				   currency,
				   valueClass,
				   currencyClass,
				   dataSet,
				   removeDoubleZeros,
				   includeDotAfterLV,
				   addPercent
			   }) => {

	const currencyMap = {
		BGN: 'лв',
		EUR: '&euro;',
		USD: '&dollar;',
	};

	let percentHtml = '';
	if (addPercent === true) {
		percentHtml = <span style={{fontSize: "18px"}}>%</span>;
	}

	if (!includeDotAfterLV) {
		currencyMap['BGN'] = 'лв';
	}

	let innerDataSet = {};
	if (dataSet) {
		Object.keys(dataSet).map((key) => {
			innerDataSet[`data-${key}`] = dataSet[key];
		});
	}

	if (typeof value === 'undefined') {
		value = 0;
	}

	value = (typeof value === 'number' ? value : Number(value.replace(/\s/g, '').replace(',', '.')));
	value = value.toLocaleString('bg-BG', {minimumFractionDigits: 2, maximumFractionDigits: 2});

	if (removeDoubleZeros) {
		value = value.replace('.00', '');
		value = value.replace(',00', '');
	}

	if (typeof (value) === 'string') {
		value = value.replace('.', ',');
	}

	if (currency === '') {
		return (
		  <span {...innerDataSet}>
        		<span className={valueClass || ''}>{value}</span>
			  {percentHtml}
      		</span>
		);
	}

	if (currency === 'BGN') {
		return (
		  <span {...innerDataSet}>
        		<span className={valueClass || ''}>{value}</span>
			  &nbsp;
			  <span className={currencyClass || ''} dangerouslySetInnerHTML={{__html: currencyMap[currency]}}/>
      		</span>
		);
	} else {
		const currencyFormatted = value < 0 ? '- ' + currencyMap[currency] : currencyMap[currency]
		return (
		  <span {...innerDataSet}>
        		<span
				  className={currencyClass || ''}
				  dangerouslySetInnerHTML={{__html: currencyFormatted}}/>
			  &nbsp;
			  <span className={valueClass || ''}>{value < 0 ? Math.abs(value) : value}</span>
			</span>
		);
	}


};

Price.defaultProps = {
	dataSet: {},
	currency: '',
	includeDotAfterLV: true,
	addPercent: false
};

Price.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	dataSet: PropTypes.objectOf(PropTypes.string),
	currency: PropTypes.string,
	valueClass: PropTypes.string,
	currencyClass: PropTypes.string,
	includeDotAfterLV: PropTypes.bool,
	addPercent: PropTypes.bool
};

export default Price;